__turbopack_context__.v({
  "backgroundImage": "AgencyFooter-module__4wjrsW__backgroundImage",
  "content": "AgencyFooter-module__4wjrsW__content",
  "ctaWrapper": "AgencyFooter-module__4wjrsW__ctaWrapper",
  "footer": "AgencyFooter-module__4wjrsW__footer",
  "footerNeutral": "AgencyFooter-module__4wjrsW__footerNeutral",
  "heading": "AgencyFooter-module__4wjrsW__heading",
  "text": "AgencyFooter-module__4wjrsW__text",
  "wrapper": "AgencyFooter-module__4wjrsW__wrapper",
});
